import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ChartOptions } from 'src/app/components/gtp-area-chart/gtp-area-chart.component';
import { IUserInfoCognito } from 'src/app/shared/services/cognito.service';
import { selectUserInfo } from 'src/app/state/selectors/userInfo.selectors';

export class LandingChart {
  label: string = "";
  amount: number = 0;
  subLabel: string = "";
  chartOptions: ChartOptions = {
    series: [
      {
        name: "series1",
        data: [31, 40, 28, 51, 42, 70, 30]
      },
    ],
    chart: {
      height: 100,
      type: "area",
      toolbar: {
        show: false
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: "smooth"
    },
    xaxis: {
      type: "datetime",
      categories: [
        "2018-09-19T00:00:00.000Z",
        "2018-09-19T01:30:00.000Z",
        "2018-09-19T02:30:00.000Z",
        "2018-09-19T03:30:00.000Z",
        "2018-09-19T04:30:00.000Z",
        "2018-09-19T05:30:00.000Z",
        "2018-09-19T06:30:00.000Z"
      ],
      labels: {
        show: false,
      }
    },
    yaxis: {
      floating: true,
      axisTicks: {
        show: false
      },
      axisBorder: {
        show: false
      },
      labels: {
        show: false
      },
      tickAmount: 4,
    },
    tooltip: {
      x: {
        format: "dd/MM/yy HH:mm"
      }
    }
  }
}

@Component({
  selector: 'app-landing-general',
  templateUrl: './landing-general.component.html',
  styleUrls: ['./landing-general.component.scss']
})
export class LandingGeneralComponent implements OnInit {

  hasOrgs: boolean = true;

  public charts: LandingChart[] = [
    {
      label: "COMPRAS CONFIRMADAS",
      amount: 320,
      subLabel: "Grandes compras",
      chartOptions: {
        series: [
          {
            name: "series1",
            data: [31, 40, 28, 51, 42, 70, 30]
          },
        ],
        chart: {
          height: 100,
          type: "area",
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "smooth"
        },
        xaxis: {
          type: "datetime",
          categories: [
            "2018-09-19T00:00:00.000Z",
            "2018-09-19T01:30:00.000Z",
            "2018-09-19T02:30:00.000Z",
            "2018-09-19T03:30:00.000Z",
            "2018-09-19T04:30:00.000Z",
            "2018-09-19T05:30:00.000Z",
            "2018-09-19T06:30:00.000Z"
          ],
          labels: {
            show: false,
          }
        },
        yaxis: {
          floating: true,
          axisTicks: {
            show: false
          },
          axisBorder: {
            show: false
          },
          labels: {
            show: false
          },
          tickAmount: 4,
        },
        tooltip: {
          x: {
            format: "dd/MM/yy HH:mm"
          }
        }
      },
    },
    {
      label: "VENTAS REALIZADAS",
      amount: 279,
      subLabel: "Ventas al por mayor",
      chartOptions: {
        series: [
          {
            name: "series1",
            data: [30, 10, 10, 5, 40, 60, 70]
          },
        ],
        chart: {
          height: 100,
          type: "area",
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "smooth"
        },
        xaxis: {
          type: "datetime",
          categories: [
            "2018-09-19T00:00:00.000Z",
            "2018-09-19T01:30:00.000Z",
            "2018-09-19T02:30:00.000Z",
            "2018-09-19T03:30:00.000Z",
            "2018-09-19T04:30:00.000Z",
            "2018-09-19T05:30:00.000Z",
            "2018-09-19T06:30:00.000Z"
          ],
          labels: {
            show: false,
          }
        },
        yaxis: {
          floating: true,
          axisTicks: {
            show: false
          },
          axisBorder: {
            show: false
          },
          labels: {
            show: false
          },
          tickAmount: 4,
        },
        tooltip: {
          x: {
            format: "dd/MM/yy HH:mm"
          }
        }
      },
    },
    {
      label: "DEVOLUCIONES",
      amount: 3.5,
      subLabel: "% de las ventas",
      chartOptions: {
        series: [
          {
            name: "series1",
            data: [31, 70, 70, 28, 11, 70, 60]
          },
        ],
        chart: {
          height: 100,
          type: "area",
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "smooth"
        },
        xaxis: {
          type: "datetime",
          categories: [
            "2018-09-19T00:00:00.000Z",
            "2018-09-19T01:30:00.000Z",
            "2018-09-19T02:30:00.000Z",
            "2018-09-19T03:30:00.000Z",
            "2018-09-19T04:30:00.000Z",
            "2018-09-19T05:30:00.000Z",
            "2018-09-19T06:30:00.000Z"
          ],
          labels: {
            show: false,
          }
        },
        yaxis: {
          floating: true,
          axisTicks: {
            show: false
          },
          axisBorder: {
            show: false
          },
          labels: {
            show: false
          },
          tickAmount: 4,
        },
        tooltip: {
          x: {
            format: "dd/MM/yy HH:mm"
          }
        }
      },
    },
  ];

  userInfo$: Observable<IUserInfoCognito> = this.store.select(selectUserInfo);


  constructor(
    private router: Router, 
    private store: Store
    ) { }

  ngOnInit(): void {
    this.userInfo$.subscribe((userInfo) => {
      this.hasOrgs = userInfo.organizations && userInfo.organizations.length > 0? true : false;
    })
  }

  createPayment() {
    this.router.navigate(['/payment']);
  }

  onClickOnboarding(){
    this.router.navigate(['/onboarding'])
  }
}
